// @ts-strict-ignore
import { withProfiler } from "@sentry/react";
import { StrictMode } from "react";

import { LazyHotReloadIndicator } from "@shared/components/LazyHotReloadIndicator/LazyHotReloadIndicator";
import { LazyReactAxe } from "@shared/components/LazyReactAxe/LazyReactAxe";
import type { ExperimentContextData } from "@shared/context/experiment/experiment.store";
import type { Flipper } from "@shared/types/flipper";
import { OAuthOnboardingFlow } from "@unauthenticated/oauth/components/OAuthOnboardingFlow/OAuthOnboardingFlow";
import { Providers } from "@unauthenticated/oauth/components/Providers/Providers";

interface Props {
  clientId: string;
  redirectUri: string;
  responseType: string;
  scopes: string;
  state: string;
  applicationName: string;
  applicationLogo: string;
  applicationAccessLevel: string;
  ssoErrors?: string;
  flippers?: Flipper[];
  ssoOrigin: string;
  currentCountry: string;
  e2e: boolean;
  nonce: string;
  prompt: string;
  maxAge: string;
}

const Main = ({ flippers, e2e, currentCountry, ...rest }: Props) => {
  const getExperimentData = (): ExperimentContextData => ({
    userId: null,
    roleId: null,
    storeId: null,
  });

  return (
    <StrictMode>
      <Providers
        flippers={flippers}
        currentCountry={currentCountry}
        e2e={e2e}
        experimentData={getExperimentData()}
      >
        <OAuthOnboardingFlow {...rest} currentCountry={currentCountry} />

        <LazyHotReloadIndicator />
        <LazyReactAxe />
      </Providers>
    </StrictMode>
  );
};

const MainWithProfiler = withProfiler(Main);
export { MainWithProfiler as Main };
